import { render, staticRenderFns } from "./Subdivision.vue?vue&type=template&id=c57a100c&scoped=true"
import script from "./Subdivision.vue?vue&type=script&lang=js"
export * from "./Subdivision.vue?vue&type=script&lang=js"
import style0 from "./Subdivision.vue?vue&type=style&index=0&id=c57a100c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57a100c",
  null
  
)

export default component.exports